import { useFetch } from "../hooks/useFetch";
import { useEffect, useRef } from "react";
import { useAuth } from "../../context/AuthContext";


export default function ReadPrefs({email,
    setSelectedCountry,
    setSelectedJurisdictionIndex,
    setQueryType,
    token
}){

    const url = email ? "api/user/preference/" + email : null;

    //alert(email)

    const { response, loading, error } = useFetch(url, token);
    const {roles} = useAuth();

    // Only hydrate once per email so user changes stick
    const didHydrate = useRef(null);

    useEffect(() => {
        if (!email) return;
        didHydrate.current = null;
    }, [email]);

    useEffect(() => {
        if (didHydrate.current || !response?.searchPreference) return;
        const pref = response.searchPreference;
        if(pref.country === "Mexico" && !roles.include("searchMx")){
            return;
        }
        if(pref.country === "Canada" && !roles.include("searchCn")){
            return;
        }
        if (pref.country) setSelectedCountry(pref.country); 
        if (Number.isInteger(pref.state)) setSelectedJurisdictionIndex(pref.state);
        if (pref.query) setQueryType(pref.query);

        didHydrate.current = true;
    }, [response, setSelectedCountry, setSelectedJurisdictionIndex, setQueryType, roles]);
console.log("EE :"+error)
    if (loading) return <h4>Loading...</h4>;
    if (error){
        if(typeof(error) !== 'object'){ 
            return <>Loading Prefs Failed</>;
        }
    }
    return null;
}

